import {createRequestThunk} from "src/store/store.helpers";
import {additionalLoanActions, deleteAdditionalLoanAction} from "src/store/additionalLoans/addLoan.actions";
import {
  createAdditionalLoan as _create,
  updateAdditionalLoan as _update,
  deleteAdditionalLoan as _delete
} from "src/services/additionalLoans/additionalLoans";


/**
 * this method makes an api call that creates additional new loan in a existing loan
 */
export const createAdditionalLoanReq = createRequestThunk(
  additionalLoanActions,
  ({ ...data }) => _create(data)
);

/**
 * this method makes an api call that updates additional loan
 */
export const updateAdditionalLoan = createRequestThunk(
  additionalLoanActions,
  ({ ...data }) => _update(data)
);
/**
 * this method makes an api call that deletes additional loan
 */
export const deleteAdditionalLoan = createRequestThunk(
  deleteAdditionalLoanAction,
  (id: string) => _delete(id)
);
